module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['reply-top-bar', _vm.item.del === '1' ? 'del' : '']
  }, [(_vm.item.del !== '1') ? _c('div', {
    staticClass: "info-l f-cb"
  }, [_c('div', {
    staticClass: "from f-fl f-toe1"
  }, [(_vm.item.area) ? _c('span', {
    staticClass: "addr"
  }, [_vm._v(_vm._s(_vm.item.area))]) : _vm._e(), _vm._v(_vm._s(_vm.item.userName) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "to"
  }, [_c('em', [_vm._v("回复：")]), _vm._v(_vm._s(_vm.item.replyTo) + "\n\t\t")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info-r"
  }, [_c('span', {
    staticClass: "floor"
  }, [_vm._v(_vm._s(_vm.item.floor) + "楼")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c68a239e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comment/reply-top-bar.vue
// module id = 864
// module chunks = 2